class PaymentLinkSender {

    constructor() {
        this.sendTrackButtonSelector = '#send_payment_link_btn';
        this.messageBox = '#payment-link-message';
    }

    init() {
        this.listenSendLink();
    }

    listenSendLink() {
        $(document).on('click', '#send_payment_link_btn', (event) => {
            event.stopPropagation();
            this.sendPaymentLink();
            return false;
        });
    }

    sendPaymentLink() {
        let self = this;
        let order_id = $('#order_id').val();
        $.post('/shop/orders/payment/resend_link', {order_id: order_id}).then((response) => {
            self.showResponse(response.message);
        }).catch((error) => {
            self.showResponse(error.responseJSON.message, true);
        });
    }

    showResponse(message, isError = false) {
        let messageBox = $(this.messageBox);
        this.setMessageClass(messageBox, isError);
        messageBox.html(message);
        messageBox.show();
    }

    setMessageClass(messageBox, isError) {
        if (isError) {
            messageBox.removeClass('success-message');
            messageBox.addClass('error-message');
        } else {
            messageBox.removeClass('error-message');
            messageBox.addClass('success-message');
        }
    }

}

export default PaymentLinkSender;
